<!-- eslint-disable max-lines -->
<template>
    <div class="customers-manage">
        <Paper class="customers-manage-paper">
            <el-tabs class="contract-list-tab-pane" v-model="activeTabs" @tab-remove="removeTab"
                @tab-click="switchTabs">
                <!-- 合同列表页 -->
                <el-tab-pane label="客户管理列表" name="theList" ref="myPane" v-loading="holePageLoading">
                    <list-layout-paper ref="listLayoutPaperRef">
                        <template slot="header-search" class="searchBox">
                            <search-box ref="searchBox" :search-key="config.name" :fields="config.searchFields"
                                :showResetBtn="true" @search-change="searchChange"
                                @elementChange="handleFielChange" @reset="reset" @saveFieldConfig="saveFieldConfig" />
                            <div class="customer-filter-radio" v-if="filterRadioOptions.length">
                                <el-radio-group v-model="viewTab" @change="handleViewTabChange" size="mini">
                                    <el-radio-button
                                        v-for="item in filterRadioOptions"
                                        :key="item.value"
                                        :label="item.value">
                                        {{ item.label }}
                                    </el-radio-button>
                                </el-radio-group>
                            </div>
                        </template>
                        <template slot="header-button" class="customer-manage-btn">
                            <lotsButton v-show="isShowAddBtn" type="primary" icon="el-icon-circle-plus-outline"
                                size="mini" title="新增">
                                <el-dropdown class="customers-manage-list-dropdown" trigger="hover"
                                    :append-to-body="false">
                                    <span class="el-dropdown-link">
                                        新增<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="customers-manage-list-dropdown-menu">
                                        <el-dropdown-item class="dropdown-item" v-has="authorityCode.legalPerson"
                                            @click.native="handleAddRow('1')">国内注册(法人/个体户)</el-dropdown-item>
                                        <el-dropdown-item class="dropdown-item" v-has="authorityCode.noLegalPerson"
                                            @click.native="handleAddRow('0')">国内注册(非法人)</el-dropdown-item>
                                        <el-dropdown-item class="dropdown-item" v-has="authorityCode.overseas"
                                            @click.native="handleAddRow('2')">海外/港澳台注册</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </lotsButton>
                            <lotsButton v-show="isShowFlowBtn" type="primary" icon="el-icon-circle-check"
                                size="mini" title="白名单配置审批发起">
                                <el-dropdown class="customers-manage-list-dropdown" trigger="hover"
                                    :append-to-body="false">
                                    <span class="el-dropdown-link">
                                        白名单配置审批发起<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="customers-manage-list-dropdown-menu">
                                        <el-dropdown-item class="dropdown-item" v-has="authorityCode.useFlow"
                                            @click.native="handleStatusFlowRow('ON')">启用审批</el-dropdown-item>
                                        <el-dropdown-item class="dropdown-item" v-has="authorityCode.stopFlow"
                                            @click.native="handleStatusFlowRow('OFF')">停用审批</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </lotsButton>
                            <lotsButton v-show="isShowExportBtn" type="primary" icon="el-icon-download" size="mini" title="导出">
                                <el-dropdown class="customers-manage-list-dropdown" trigger="hover" :append-to-body="false">
                                    <span class="el-dropdown-link">
                                        导出<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="customers-manage-list-dropdown-menu">
                                        <el-dropdown-item v-has="authorityCode.export" class="dropdown-item" @click.native="handleExport('0')">导出</el-dropdown-item>
                                        <el-dropdown-item v-has="authorityCode.localCustomerManagerExport" class="dropdown-item" @click.native="handleExport('1')">属地客户经理维度导出</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="属地客户经理导入"
                                icon="el-icon-upload2"
                                v-has="authorityCode.localCustomerManagerImport"
                                @click="handleImport"
                            >属地客户经理导入</lotsButton>

                            <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                                <el-button icon="iconfont icon-list_install" type="primary" size="mini" :title="'列配置'"
                                    @click="showColumnConfigDialog" plain />
                            </el-tooltip>

                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <table-box ref="customerManageRef" :tableID="config.name" :height="tableHeight"
                                v-loading="accountList.tableLoading" :selection="config.selection" :index="config.index"
                                :columns="config.columns" :rows="accountList.totalData" :actions="config.actions"
                                @action-click="actionClick" @selection-change="accountList.handleSelectedRow"
                                @sort-change="handleSort" @col-filter="colFilter" @element-change="colElementChange"
                                @row-dblclick="(row) => rowDBclick(row)">
                                <template #col-header="{ col }">
                                    <span class="slot-box slot-header-title" v-if="['idNumber'].includes(col.prop)">
                                        <span class="">
                                            {{ col.label }}
                                        </span>
                                        <img  class="text-eyes" @click="handleChangeText(col)"
                                            :src="encryption[col.prop] ? iconOpenEyes : iconCloseEyes" alt="">
                                    </span>
                                    <span class="slot-header-title" v-else> {{ col.label }}</span>
                                </template>
                                <template #col-append="{ col, row, rIndex }">
                                    <span v-if="col.prop === 'calCustomerLevel'">{{ codesToNames(row[col.prop],
                                        dictData[col.optionsKey]) }}</span>
                                    <span size="mini" v-else-if="col.prop==='customerWhitelistCode'" type="text" class="customer-mip-page-link no-wrap"
                                    @click="handleLink(row)">{{  row.customerWhitelistCode}}</span>
                                    <span size="mini" v-else-if="col.prop==='idNumber'" type="text" class="mip-page-link no-wrap" :title="row[col.prop]">{{
                                        encryptionHandle(row[col.prop] || '', col.prop) }}
                                    </span>

                                </template>
                            </table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination @size-change="accountList.sizeChange"
                                :current-page.sync="accountList.pageNo" @current-change="accountList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper" :total="accountList.pageTotal">
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>
                <!-- 详情页签 -->
                <el-tab-pane closable :class="item.code + item.detailPageState" v-for="item in tabList"
                    :key="item.code + item.detailPageState" :label="item.contractMark" class="customer-name-tab"
                    :name="item.code + item.detailPageState">
                    <detail-page :ref="`datailTabs${item.code + item.detailPageState}`" :code="item.code"
                        :key="item.detailPageState" @other-change="openOtherCustomerDetail" :activeTabs="activeTabs"
                        :detailPageState="item.detailPageState" :disableBus="item.buttonData" @save-data="saveData"
                        :detailData="item.detailData">
                    </detail-page>
                </el-tab-pane>
            </el-tabs>

            <!-- 导入弹窗 -->
            <addFileDialog
                ref="fileDialogRef"
                :config="config.importConfig"
                @uploadSuccessHandle="accountList.getList()"
                @uploadFailHandle="accountList.getList()"
            />
            <!-- 表格列配置弹框 -->
            <column-config :pageID="config.name" :initColumns="config.columns" ref="otpColumnConfig"
                @header-change="config.columns = $event" />

            <!-- 客户新增 -->
            <customer-add-dialog ref="customerAddDialog" @addNewConfirm="addNewConfirm">
            </customer-add-dialog>

        </Paper>
    </div>
</template>
<script>
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
// import editTableBox from '@/components/lots/editTableBox/Index';
import tableBox from '@/components/lots/tableBox/Index';
import { getCustomerPage, customerExport, getCustomerByCode, verifyWhiteCustomer, getCustomerListReport } from '@/modules/mdm/api/customer/customerManage.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic, verifyWhiteCustomerFunc } from './config';
import { ref, reactive, onMounted, onActivated, computed, getCurrentInstance } from '@vue/composition-api';
import { Message } from 'element-ui';
import utils from '@/components/utils/common.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import _ from 'lodash';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { getIndustryTree } from '@mdm/api/contractManage/contractRegistration.js';
import { exportLocalCustomerManager } from '@mdm/api/customer/customerSeries.js';
import lotsButton from '@/components/lots/lotsButton';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import columnConfig from '@/components/lots/columnConfig/Index';
import detailPage from './detail/Detail.vue';
import customerAddDialog from './component/customerAddDialog/Index.vue';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import store from '@/store/index';
import bigDataLog from '@/utils/bigDataLog.js';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
const { MAGIC_NUMBER } = utils;

export default {
    name: 'customerManage',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        tableBox,
        // editTableBox,
        lotsPagination,
        lotsButton,
        addFileDialog,
        columnConfig,
        detailPage,
        customerAddDialog
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(configStatic);
        const searchObj = reactive({});
        const authorityCode = reactive(btnAuthority.customerManage);
        const isShowAddBtn = computed(() => {
            const { legalPerson, noLegalPerson } = btnAuthority.customerManage;
            return otherUtils.getHasAuth(legalPerson) || otherUtils.getHasAuth(noLegalPerson);
        });
        const isShowFlowBtn = computed(() => {
            const { stopFlow, useFlow } = btnAuthority.customerManage;
            return otherUtils.getHasAuth(stopFlow) || otherUtils.getHasAuth(useFlow);
        });
        const isShowExportBtn = computed(() => {
            return otherUtils.getHasAuth(authorityCode.export) || otherUtils.getHasAuth(authorityCode.localCustomerManagerExport);
        });
        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                bigDataLog.sendDetailMessageByKey('bigData-btn-customer-list-search');
                return searchDataFormat(condition);
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        v.edit = -3;
                        v.allowEdit = true;
                        return v;
                    });
                    this.pageTotal.value = res.data.totalCount;
                    setupContext.root.$nextTick(() => {
                        setupContext.refs.customerManageRef.$refs.elTable.doLayout(); // 解决表格错位
                    });
                }
            };
        }
        const accountList = new AccountListClass({
            Api: {
                listApi: getCustomerPage // 查询接口
            }
        });
        // 搜索
        const searchChange = (param) => {
            const newParams = _.cloneDeep(param);
            // 细分行业
            newParams.industryType = '';
            if (param.industryType && param.industryType.length) {
                newParams.industryCategoriesCode = param.industryType[0] || '';
                newParams.industryType = param.industryType[1] || '';
            }
            newParams.viewTab = viewTab.value;
            accountList.searchList(newParams);
        };
        // 重置自定义搜索条件
        const reset = () => {
            handleFielChange({ column: { value: 'industryCategoriesCode' }, searchData: {} });
        };
        // 保存自定义搜索条件
        const saveFieldConfig = async ({ showConfig, searchData }) => {
            if (showConfig.includes('industryType')) {
                const { filterOptions } = await getIndustryList(searchData.industryCategoriesCode);
                config.searchFields.find((v) => v.value === 'industryType').options = filterOptions; // 细分行业下拉项
            }
        };
        const handleFielChange = _.debounce(async ({ column, searchData }) => {
            if (searchData.contractCodes) {
                const orderNoS = searchData.contractCodes.split(/,|，|;|；|\r|\n|\r\n|\s+/);
                searchData.contractCodes = orderNoS.join(';');
            }
            // 行业大类
            if (column.value === 'industryCategoriesCode') {
                const { filterOptions } = await getIndustryList(searchData[column.value]);
                config.searchFields.find((v) => v.value === 'industryType').options = filterOptions; // 细分行业下拉项
                searchData.industryType = '';
            }
            // 细分行业
            if (column.value === 'industryType' && searchData[column.value].length) {
                searchData.industryCategoriesCode = searchData[column.value][0];
            }
        }, MAGIC_NUMBER.TWO_HUNDRED);
        const currentFilterObj = ref({}); // 用于保存需要筛选的多个字段
        // eslint-disable-next-line complexity
        const searchDataFormat = (condition = {}, params = {}) => {
            condition.orderBy = orderBy.value;
            condition.orderByType = orderByType.value;
            const _params = { ...condition, ...params };
            // _params.viewTab = _params.viewTab || viewTab.value
            if (!_.isNil(_params.customerLevelCode)) {
                if (Array.isArray(_params.customerLevelCode) && _params.customerLevelCode.length === 0) {
                    delete _params.customerLevelCode;
                    delete _params.ebcuCustomerLevel;
                    delete currentFilterObj.value['ebcuCustomerLevel'];
                } else {
                    _params.ebcuCustomerLevel = _params.customerLevelCode;
                    delete _params.customerLevelCode;
                }
            } else {
                delete _params.customerLevelCode;
                delete _params.ebcuCustomerLevel;
                delete currentFilterObj.value['ebcuCustomerLevel'];
            }
            Object.keys(_params).forEach(v => {
                !_params[v] && _params[v] !== 0 && (_params[v] = undefined);
            });
            const page = { ..._.pick(_params, ['pageNo', 'pageSize', 'pushStatusNonDynamic']) };
            const filterCondition = _.omit(_params, ['pageNo', 'pageSize', 'orderBy', 'orderByType', 'pushStatusNonDynamic']);
            const keys = Object.getOwnPropertyNames(filterCondition);
            for (let key = 0; key < keys.length; key++) {
                const keyName = keys[key];
                const filterConditionVal = filterCondition[keyName]; // 筛选的字段值
                currentFilterObj.value[keyName] = filterConditionVal;
            }
            // 最新查询条件格式化
            const _params2 = otherUtils.convertObject(currentFilterObj.value, config.matchOperator);
            const viewTabVal = _params.viewTab; // viewTab是在外面的
            return { ..._params2, ...page, ...(viewTabVal !== undefined ? { viewTab: viewTabVal } : {}) };
        };
        const tabList = ref([]); // 打开的详情tab页集
        const activeTabs = ref('theList');
        const removeTab = (targetName) => { // 删除详情标签
            if (activeTabs.value === targetName) {
                activeTabs.value = 'theList';
                jumpToDetail();
            }
            tabList.value = tabList.value.filter(
                (tab) => (tab.code + tab.detailPageState) !== targetName
            );
        };
        const switchTabs = (data) => {
            if (data.name !== 'theList') {
                const currentTab = tabList.value[Number(data.index) - 1];
                if (currentTab.code === ctx.$route.query.customerCode) return;
                jumpToDetail({ customerCode: currentTab.code });
            } else {
                jumpToDetail();
            }
        };
        // 跳转至详情
        const jumpToDetail = (query = {}) => {
            ctx.$router.replace({ path: '/mod/mdm/customer-manage', query });
            bigDataLog.sendDetailMessageByKey('bigData-page-customer-detail');
        };
        const currDetailData = ref({});
        // 双击表格
        const rowDBclick = (row, status = 'main', name = '客户') => {
            // 滚动到顶部
            const element = document.getElementsByClassName('app-main');
            element[0].scrollTo(0, 0);
            currDetailData.value = _.cloneDeep(row); // 深拷贝是防止表格源数据被修改
            const { customerCode } = row;
            const code = customerCode;
            if (status !== 'new') {
                name = row.customerName;
            }
            newDetailPage(code, currDetailData.value, name, status);
        };
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const newDetailPage = (code, data, name, state) => {
            data.customerStatus = data['customerStatus'] ? data['customerStatus'] : 0;
            const judge = tabList.value.filter((item) => (item.code + item.detailPageState) === code + state);
            const insertBeforeJudge = tabList.value.filter((item) => (item.code === code && item.detailPageState !== state));
            if (judge.length === 0 && tabList.value.length === 8) {
                Message.warning('已超出8个详情页，请关闭后重新打开');
            } else {
                const dataGather = {
                    contractMark: name,
                    code,
                    detailData: _.cloneDeep(data),
                    detailPageState: state
                };
                // 新增判断页签数据调整
                if (judge.length === 0 && insertBeforeJudge.length === 0) {
                    // 第一次打开
                    tabList.value.push(dataGather);
                }
                // 编辑时更新当前数据- 新增的页签替换成查看详情
                const _index = tabList.value.findIndex((item) => ((item.code + item.detailPageState) === code + state) || (item.code === code && item.detailPageState !== state));
                if (_index > -1 && !_.isEqual(data, tabList.value[_index].detailData)) {
                    tabList.value[_index] = dataGather;
                }
                activeTabs.value = code + state; // tabs切换到对应详情页
                if (code === ctx.$route.query.customerCode) return;
                jumpToDetail({ customerCode: code });
            }
        };
        const holePageLoading = ref(false);
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };

        const theRow = ref({});

        const actionClick = (event, row, index) => {
            if (event === 'edit') {
                rowDBclick(row);
            }
        };
        // 表头筛选
        const colFilter = (param, col) => {
            const newParams = _.cloneDeep(param);
            // 重置行业大类时，更新细分行业
            if (col?.prop === 'industryCategoriesCode') {
                colElementChange(col);
            }
            // 细分行业
            const filterModel = config.columns.find((v) => v.prop === 'industryType').filterModel;
            newParams.industryType = '';
            if (filterModel && filterModel.length) {
                newParams.industryCategoriesCode = filterModel[0] || '';
                newParams.industryType = filterModel[1] || '';
            }
            newParams.viewTab = viewTab.value;
            accountList.searchList(newParams);
        };
        // 表头筛选条件发生变化时回调
        const colElementChange = async (col) => {
            // 行业大类
            if (col.prop === 'industryCategoriesCode') {
                const { filterOptions } = await getIndustryList(col.filterModel);
                config.columns.find((v) => v.prop === 'industryType').filterOptions = filterOptions; // 细分行业下拉项
                config.columns.find((v) => v.prop === 'industryType').filterModel = '';
            }
            // 细分行业
            if (col.prop === 'industryType' && col.filterModel.length) {
                config.columns.find((v) => v.prop === 'industryCategoriesCode').filterModel = col.filterModel[0];
            }
        };

        const orderBy = ref('');
        const orderByType = ref('');
        // 排序
        const handleSort = ({ prop, order }) => {
            orderBy.value = prop.replace(/([A-Z])/g, '_$1').toLowerCase();
            orderByType.value = order === 'ascending' ? 'asc' : 'desc';
            accountList.getList();
        };
        const codesToNames = computed(() => {
            function codeToName(codes, dictObj) {
                const names = [];
                const codesArr = codes ? codes.split(',') : [];
                if (codesArr && codesArr.length) {
                    codesArr.forEach((key) => {
                        if (dictObj && dictObj[key]) {
                            names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                        }
                    });
                }
                return names.join(',');
            };
            return codeToName;
        });

        const handleAddRow = async (val) => { // 新增
            const params = {
                customerBodyType: val
            };
            if (val === '0') {
                params.isImpExpCustomer = '0';
            } else if (val === '2') {
                params.isImpExpCustomer = '1';
            }
            setupContext.refs.customerAddDialog.show(params);
        };

        const handleStatusFlowRow = async (val) => { // 白名单配置审批发起
            // 检查是否至少选择了一行
            if (!accountList.selectedRows.value.length) {
                Message.warning('请至少选择一行客户');
                return;
            }

            const errorTextList = verifyWhiteCustomerFunc(accountList.selectedRows.value, val);

            if (errorTextList.length) {
                Message.warning({
                    message: errorTextList,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            // 所有校验通过，这里可以继续后续的审批发起逻辑
            // TODO: 调用审批发起的API
            const params = {
                customerIdList: accountList.selectedRows.value.map(it => it.ebcuId),
                whitelistType: val
            };
            verifyWhiteCustomer(params).then(res => {
                if (res && +res.code === 0) {
                    // Message.success('校验通过，可以发起审批');
                    const uuid = utils.uuid();
                    store.commit('updateCustomerWhiteList', { id: uuid, flowType: val, list: accountList.selectedRows.value });
                    ctx.$router.push({ path: '/whiteListFlow', query: { uuid: uuid, flowType: val } });
                }
            });
        };
        // 导出
        const handleExport = async (type) => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = accountList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
            const excelFileList = otherUtils.sortColumnsByFixed(config.columns)?.filter(it => it.property !== 'file');
            // 最新格式化导出
            const excelTitleList = excelFileList?.map((item) => ({
                name: item.name,
                property: item.property === 'industryCategoriesCode' ? 'industryCategoriesName' : (item.property === 'industryType' ? 'industryTypeName' : item.property)
            }));
            const params = {
                ...newData,
                deleteFlag: 0,
                excelTitleList
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            // type：0-导出 1-属地客户经理维度导出
            const api = type === '1' ? exportLocalCustomerManager : customerExport;
            api(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { });

            // 埋点
            if (type === '0') {
                bigDataLog.sendDetailMessageByKey('bigData-btn-customer-list-export');
            }
        };
        // 导入
        const handleImport = () => {
            setupContext.refs.fileDialogRef.openImport();
        };
        const addNewConfirm = (data, status, name) => {
            rowDBclick(data, status, name);
        };
        const saveData = (data, status, name) => {
            tabList.value = tabList.value.filter(item => {
                return item.code;
            });
            rowDBclick(data, status, data.customerName);
        };
        // const currentCustomerData = ref({});
        const openOtherCustomerDetail = (code) => {
            const params = {
                customerCode: code
            };
            return getCustomerByCode(params).then(res => {
                if (res && +res.code === 0) {
                    // currentCustomerData.value = res.data;
                    rowDBclick(res.data);
                }
            });
        };
        const handleLink = (row) => {
            if (row.customerWhitelistCode) {
                ctx.$router.push({ path: '/whiteListFlow', query: { customerWhitelistCode: row.customerWhitelistCode } });
            }
        };
        // 获取行业大类数据
        const getIndustryList = async (industryCategoriesCode = undefined) => {
            // 获取行业大类与细分行业级联数据
            const { data } = await getIndustryTree({ industryStatus: 1, industryCategoriesCode }); // 0-停用、1-启用
            const filterOptions = data || []; // 行业大类下拉项(form)/细分行业下拉项
            const categoryOptions = {}; // 行业大类下拉项(table)
            const typeOptions = {}; // 细分行业列表展示名称转换项
            filterOptions.forEach((v) => {
                v.label = v.industryName;
                v.value = v.industryCode;
                categoryOptions[v.industryCode] = v.industryName;
                v.children && v.children.forEach((c) => {
                    typeOptions[c.industryCode] = c.industryName;
                });
            });
            return { categoryOptions, typeOptions, filterOptions };
        };
        onActivated(() => {
            // setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        const dictData = ref({});
        onMounted(async () => {
            await initCustomerRole();
            const filterParams = {};
            if (viewTab.value) {
                filterParams.viewTab = viewTab.value;
            }
            const res = await getDictDataApi({
                dictCodes: 'NEOCRM_CUSTOMER_LEVEL,SYS_BMS_BUSI_TYPE,CRM_CONTRACT_RENEWAL_RISK,NEOCRM_WH_TYPE,CRM_CONTRACT_RENEWAL_RISK,CRM_CONTRACT_RENEWAL_RISK_CAUSE,CUSTOMER_PUSH_STATUS'
            });
            dictData.value = res.data;

            // 获取行业大类
            const { categoryOptions, typeOptions, filterOptions } = await getIndustryList();
            config.searchFields.find((v) => v.value === 'industryCategoriesCode').options = filterOptions; // 行业大类下拉项(form)
            config.searchFields.find((v) => v.value === 'industryType').options = filterOptions; // 细分行业下拉项
            config.columns.find((v) => v.prop === 'industryCategoriesCode').options = categoryOptions; // 行业大类下拉项(table)
            config.columns.find((v) => v.prop === 'industryType').filterOptions = filterOptions; // 细分行业下拉项
            config.columns.find((v) => v.prop === 'industryType').options = typeOptions; // 细分行业列表展示名称转换项

            const queryParams = {};
            if (viewTab.value) {
                queryParams.viewTab = viewTab.value;
            }
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
            if (ctx.$route.query.customerCode) {
                try {
                    await openOtherCustomerDetail(ctx.$route.query.customerCode);
                    // eslint-disable-next-line no-empty
                } catch (error) {
                }
            }
        });
        const encryption = ref({
            idNumber: false
        });
        const handleChangeText = (item) => {
            encryption.value[item.prop] = !encryption.value[item.prop];
        };
        // 对应加密方法
        const menuList = {
            idNumber: 'idCard'
        };
        const encryptionHandle = (val, p) => {
            const { desensitization } = otherUtils;
            const prop = menuList[p];
            if (!desensitization[prop]) return '';
            if (encryption.value[p]) return val;
            return desensitization[prop](val);
        };
        const viewTab = ref('');
        const filterRadioOptions = ref([]);
        const handleViewTabChange = (val) => {
            const queryParams = {
                viewTab: val
            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
        };
        const initCustomerRole = async () => {
            try {
                const res = await getCustomerListReport({});
                if (res && +res.code === 0) {
                    const viewTabOptions = res.data || {};
                    filterRadioOptions.value = viewTabOptions.map(item => ({
                        value: String(item.viewTab),
                        label: item.viewName
                    }));
                    const defaultOption = viewTabOptions.find(item => item.default);
                    viewTab.value = defaultOption ? String(defaultOption.viewTab) : '';
                    if (!viewTab.value && filterRadioOptions.value.length > 0) {
                        viewTab.value = filterRadioOptions.value[0].value;
                    }
                } else {
                    viewTab.value = '';
                    filterRadioOptions.value = [];
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.listLayoutPaperRef && setupContext.refs.listLayoutPaperRef.resetTableHeight();
                });
            } catch (error) {
                viewTab.value = '';
                filterRadioOptions.value = [];
            }
        };
        return {
            accountList,
            config,
            otpColumnConfig,
            encryption,
            iconOpenEyes,
            iconCloseEyes,
            showColumnConfigDialog,
            holePageLoading,
            utils,
            authorityCode,
            handleExport,
            handleImport,
            handleSort,
            codesToNames,
            searchChange,
            reset,
            handleFielChange,
            saveFieldConfig,
            dictData,
            actionClick,
            colFilter,
            colElementChange,
            theRow,
            removeTab,
            switchTabs,
            rowDBclick,
            activeTabs,
            tabList,
            isShowAddBtn,
            isShowFlowBtn,
            isShowExportBtn,
            handleAddRow,
            handleStatusFlowRow,
            searchObj,
            addNewConfirm,
            saveData,
            openOtherCustomerDetail,
            handleLink,
            handleChangeText,
            encryptionHandle,
            viewTab,
            filterRadioOptions,
            handleViewTabChange
        };
    }
};
</script>
<style lang="less">
.customers-manage {
  width: 100%;

  .customers-manage-paper {
    height: 100%;
  }

  .list-layout-wrapper {
    height: 100%;
  }

  .contract-list-tab-pane.el-tabs {
    width: 100%;
    height: 100%;

    & > .el-tabs__content {
      height: calc(100% - 40px - 14px);
      overflow: auto;

      & > .el-tab-pane {
        overflow: auto;
        padding-right: 5px;
        height: 100%;

        .list-main {
          .table-box {
            height: 100%;
          }
        }
      }
    }
  }

  .flex-layout .list-main {
    overflow: auto;
  }

  .flex-layout .table {
    overflow-y: auto;
  }

  .list-header {
    .customers-manage-list-dropdown.el-dropdown {
      color: #fff;
      font-size: 12px;
    }
  }

  .customer-filter-radio {
    display: inline-flex;
    align-items: center;

    .el-radio-group {
      display: inline-flex;
    }

    .el-radio-button__inner {
      padding: 7px 12px !important;
      line-height: 1;
    }
  }

  .layout-content.customers-manage-paper {
    padding: 0 20px 20px;

    .el-table .cell.el-tooltip {
      & > div {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .list-layout-wrapper {
    padding: 0;
  }

  .red-color {
    color: red;
  }

  .upload-btn {
    display: flex;
    // padding: 0px 0px 15px 80px;
    margin: 0 0 0 8px;

    .upload-demo {
      margin-left: 10px;
    }
  }

  .list-layout .list-header .el-input {
    margin-left: 0;
  }

  .list-layout .list-header .header-search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .header-button::after {
    content: "";
    display: table;
    clear: both;
  }

  .header-button button {
    float: left;
    margin-bottom: 10px;
  }

  .text-eyes {
    width: 14px;
    margin-left: 4px;
    cursor: pointer;
    position: relative;
    top: 2px;
  }

  .slot-header-title {
    width: 100%;
    display: inline-block;
  }
}

.customers-manage-list-dropdown.el-dropdown {
  color: #fff;
  vertical-align: middle;

  .el-button--mini {
    padding: 7px 15px;
  }
}

.customers-manage-list-dropdown-menu {
  background: #fff;
  padding: 0;
  white-space: nowrap;

  .dropdown-item {
    width: 130px !important;
    color: #333;
    font-size: 14px;
    padding: 8px 20px;
    line-height: 1.5;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    text-align: center;
    justify-content: center;
    display: flex;
    color: #4285f5;
  }

  .dropdown-item:hover {
    background: #f5f7fa;
    color: #4285f5;
  }
}

.column-config_title {
  font-size: 14px;
}

.resg-mip-link {
  text-decoration: none;
  display: inline-flex;
}

.customer-mip-page-link {
  color: #4285f5;
  cursor: pointer;

  &.no-wrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
